export default "__VITE_ASSET__iQGKSWXy__"